import './theme.scss';
import './all-blocks'
import registerColors from "./shared/color";
import { isEditing } from "./shared/utils";
import { setupWordpressSupport } from "./categories";
import {registerSmartFormBlocks} from '@smartfire/gutenberg-react';

if (isEditing()) {
    registerColors();
}

registerSmartFormBlocks();

setupWordpressSupport();

// Uncomment the following code to have a full PWA:
//
// async function renderDOM() {
//
//     if(window['smartfire'] && window['smartfire'].components) {
//         const promisedComponents = (Object.values(window['smartfire'].components) as (() => Promise<any>)[]).map((block: () => Promise<any>) => block());
//         if(promisedComponents.length > 0)
//             await Promise.all(promisedComponents);
//     }
//
//     await (async function(){
//         const [React, ReactDOM] = await Promise.all([(await import("react")), (await import("react-dom"))]);
//         const App = (await import("./App")).App;
//         ReactDOM.render(React.createElement(App, {}, null), document.getElementById("root"));
//     })()
// }
// renderDOM()

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PW
// (async () => {
//     const serviceWorker = await import("./serviceWorker");
//     serviceWorker.unregister();
// })();

